import Project from 'models/project/project.model';
import TicketAttributeValue from 'models/ticket-attribute-value/ticket-attribute-value.model';
import User from 'models/user/user.model';
import GeoJSONPoint from 'models/geojson-point/geojson-point.model';
import ExternalFeature from 'models/external-feature/external-feature.model';
import TicketStatus from 'models/ticket-status/ticket-status.model';
import TicketCategory from 'models/ticket-category/ticket-category.model';

export default class Ticket {
    public id = '';
    public nr: string = "";
    public counter: number = 0;
    public project: Project = new Project();
    public ticketAttributeValues: TicketAttributeValue[] = [];
    public position: GeoJSONPoint<{}> = new GeoJSONPoint();
    public externalFeatures: ExternalFeature[] = [];
    public ticketStatus: TicketStatus = new TicketStatus();
    public createdAt: Date = new Date();
    public createdBy: User = new User();
    public description: string = '';
    public ticketCategory: TicketCategory = new TicketCategory();
    public address: string = "";
    public hasImage: boolean = false;
    public hasSound: boolean = false;

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.ticketAttributeValues) {
            this.ticketAttributeValues = [];
            for (let i = 0; i < model.ticketAttributeValues.length; i++) {
                this.ticketAttributeValues.push(
                    new TicketAttributeValue(model.ticketAttributeValues[i])
                );
            }
        }
        if (model.externalFeatures) {
            this.externalFeatures = [];
            for (let i = 0; i < model.externalFeatures.length; i++) {
                this.externalFeatures.push(
                    new ExternalFeature(model.externalFeatures[i])
                );
            }
        }
        if (model.position) {
            this.position = new GeoJSONPoint(model.position);
        }
        if (model.project) {
            this.project = new Project(model.project);
        }
        if (model.ticketStatus) {
            this.ticketStatus = new TicketStatus(model.ticketStatus);
        }
        if (model.createdAt) {
            this.createdAt = model.createdAt;
        }
        if (model.createdBy) {
            this.createdBy = new User(model.createdBy);
        }
        if (model.counter) {
            this.counter = Number(model.counter);
        }
        if (model.nr) {
            this.nr = String(model.nr);
        }
        if (model.description) {
            this.description = model.description;
        }
        if (model.ticketCategory) {
            this.ticketCategory = new TicketCategory(model.ticketCategory);
        }
        if (model.address) {
            this.address = String(model.address);
        }
        if (model.hasImage) {
            this.hasImage = Boolean(model.hasImage);
        }
        if (model.hasSound) {
            this.hasSound = Boolean(model.hasSound);
        }
    }
}
